import { createSelector } from 'reselect'

export const getVehiclePart = createSelector(
  state => state && state.vehicleParts && state.vehicleParts.detail && state.vehicleParts.detail.item ? state.vehicleParts.detail.item : null,
  part => part
)
